import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';

export default function hasScopeAndStrategyGuidedWorkflowReducer(
	state = initialstate.hasScopeAndStrategyGuidedWorkflow,
	action
) {
	switch (action.type) {
		case types.GET_SCOPE_AND_STRATEGY_GUIDED_WORKFLOW:
			if (action.response) {
				let propertyArray = Object.keys(action.response);
				let hasScopeAndStrategyGuidedWorkflow = false;
				hasScopeAndStrategyGuidedWorkflow = propertyArray.some((property) => !_.isEmpty(action.response[property]));
				return hasScopeAndStrategyGuidedWorkflow;
			} else {
				return state;
			}
		default:
			return state;
	}
}
